import Image from 'next/image'
import { useEffect } from 'react'

import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'

import useKSPSTrackEvent from '../hooks/useKSPSTrackEvent'

export const KSReviewSheetContent = (props) => {
  const { KSPSTrackEvent } = useKSPSTrackEvent()
  const { sheetType, onChangeSheetState, onContinueClick, onSubmissionClick } =
    props

  useEffect(() => {
    if (sheetType === 'success') {
      KSPSTrackEvent({
        event_name: 'enter_file_review_submitted',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sheetType])

  if (sheetType === 'confirm')
    return (
      <>
        <div className="flex flex-col ">
          <Text variant="heading-sm" className=" mb-1">
            Kumpulkan berkas?
          </Text>
          <Text variant="body-sm" color="subdued" className="my-2">
            Pastikan semua berkas yang Anda kumpulkan benar dan memenuhi syarat.
            Setelah dikumpulkan, berkas tidak dapat dihapus/diubah.
          </Text>
        </div>
        <Button
          className="my-2"
          color="blue"
          fullWidth
          onClick={() => {
            onSubmissionClick()
            KSPSTrackEvent({
              event_name: 'click_file_review_submit_now',
            })
          }}
        >
          Ya, kumpulkan sekarang
        </Button>
        <Button
          color="white"
          className="mb-2"
          fullWidth
          onClick={() => onChangeSheetState(false)}
        >
          Cek ulang berkas
        </Button>
      </>
    )

  return (
    <>
      <div className="flex flex-row items-start">
        <div>
          <Text variant="action" className="mb-1">
            Berkas berhasil dikumpulkan dan akan dicek oleh Dinas!
          </Text>
          <Text variant="body-sm" color="subdued" className="my-2 mb-4">
            Hasil pengecekannya akan diumumkan nanti pada{' '}
            <strong>Seleksi Kepala Sekolah</strong> di Beranda.
          </Text>
        </div>
        <Image
          src={'/images/bcks/img-folder-file-document-download.png'}
          alt={'image-placeholder'}
          width={100}
          height={100}
        />
      </div>
      <Button color="black" fullWidth onClick={onContinueClick}>
        Saya mengerti
      </Button>
    </>
  )
}
